import styled from '@emotion/styled'
import { Container, Paper, Box, Typography } from '@mui/material'
import { typography } from '@resiliatech/birdsong'
import { colors } from '../../../../Themes/Colors'

export const PageContainer = styled(Container)`
  padding-top: 32px;
  padding-bottom: 32px;
`

export const PagePaper = styled(Paper)`
  padding: 32px;
  background-color: ${colors.resiliaWhite};
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
`

export const PageHeader = styled(Box)`
  margin-bottom: 32px;
  border-bottom: 2px solid ${colors.lightGrey};
  padding-bottom: 24px;
`

export const PageTitle = styled(Typography)`
  ${typography.up5.semiBoldSans}
  color: ${colors.darkGrey};
  margin-bottom: 8px;
`

export const PageSubtitle = styled(Typography)`
  ${typography.up2.regularSans}
  color: ${colors.mediumGrey};
`
